import { VicFormsRegistrationWizardData } from "./models";
import axios from "axios";

interface RegistrationPayload {
  userName: string;
  password: string;
  organisationName: string;
  firstName: string;
  lastName: string;
  address: string;
  phone: string;
  mobile: string;
  fax?: string;
  abn: string;
}

export async function submitVicFormsRegistration(
  values: VicFormsRegistrationWizardData
) {
  const {
    ORGANISATION: { abn, address, organisationName, userName },
    PRIMARY_CONTACT: { firstName, lastName, mobile, phone, fax },
  } = values;

  const payload: RegistrationPayload = {
    abn: abn.toString(),
    address: address,
    fax: fax,
    firstName: firstName,
    lastName: lastName,
    mobile: mobile,
    organisationName: organisationName,
    password: "",
    phone: phone,
    userName: userName,
  };


  await axios.post(
    `${process.env.REACT_APP_VICFORMS_API_URL}/api/hutly/public/accounts/registration`,
    payload,
    {
      headers: {

      },
    }
  );
}
